import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { BusinessService } from '../../services/business.service';
import { GroupedBusiness, GroupedImageType, MembershipBranchImageType, PreRegisterBusinessImageData, PreRegisterImageGroupResponse } from '../../models/register-business';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreRegisterBusinessImageConfigurationComponent } from '../../shared/components/pre-register-business-image-configuration/pre-register-business-image-configuration.component';

@Component({
  selector: 'app-pre-registration-review',
  templateUrl: './pre-registration-review.component.html',
  styleUrls: ['./pre-registration-review.component.scss']
})
export class PreRegistrationReviewComponent implements OnInit {
  reviewData: PreRegisterImageGroupResponse[] = [];
  visibleData: PreRegisterImageGroupResponse[] = [];
  itemsPerPage: number = 100;
  currentOffset: number = 0;
  totalPages: number;
  currentBatchId: number;
  groupedImageData: GroupedBusiness[] = [];

  constructor(private businessService: BusinessService,
    private loaderService: LoaderService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.getlist();
  }

  getlist() {
    this.loaderService.setLoading(true);
    this.businessService.getBusinessImages()
      .subscribe((response: any) => {
        this.totalPages = response.total;
        this.reviewData = response.records;
        this.loadMoreData();
        this.loaderService.setLoading(false);
      });
  }

  loadMoreData() {
    const next = this.reviewData.slice(this.currentOffset, this.currentOffset + this.itemsPerPage);
    this.visibleData = [...this.visibleData, ...next];
    this.currentOffset += this.itemsPerPage;
  }

  onScroll(event: any) {
    const target = event.target;
    const threshold = 150;

    if (target.scrollHeight - target.scrollTop <= target.clientHeight + threshold) {
      this.loadMoreData();
    }
  }

  openimageConfigurationModal(imageData: PreRegisterBusinessImageData[], currentBatchId: number) {
    this.currentBatchId = currentBatchId;
    this.groupedImageData = this.groupByBusinessAndImageType(imageData);
    const modalRef = this.modalService.open(PreRegisterBusinessImageConfigurationComponent, {
      windowClass: "project-modal edit-food-menu-modal",
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.groupedImageData = this.groupedImageData;
    modalRef.componentInstance.currentBatchId = currentBatchId;
    modalRef.result.then((event: any) => {
      this.visibleData = [];
      this.currentOffset = 0;
      this.itemsPerPage = 10;
      this.getlist();
    });
  }

  groupByBusinessAndImageType(flatData: PreRegisterBusinessImageData[]): GroupedBusiness[] {
    const businessMap = new Map<number, { businessName: string, approvalStatus: number, imageTypeMap: Map<MembershipBranchImageType, GroupedImageType> }>();

    for (const item of flatData) {
      if (!businessMap.has(item.businessId)) {
        businessMap.set(item.businessId, {
          businessName: item.businessName,
          approvalStatus: item.approvalStatus,
          imageTypeMap: new Map<MembershipBranchImageType, GroupedImageType>()
        });
      }

      const businessEntry = businessMap.get(item.businessId)!;

      if (!businessEntry.imageTypeMap.has(item.imageTypeId)) {
        businessEntry.imageTypeMap.set(item.imageTypeId, {
          imageTypeId: item.imageTypeId,
          isAllTypeImagesUploaded: true,
          totalImages: 0,
          totalUploadedImages: 0,
          imageTypeData: []
        });
      }

      const imageTypeEntry = businessEntry.imageTypeMap.get(item.imageTypeId);

      imageTypeEntry.imageTypeData.push({
        id: item.id,
        branchId: item.branchId,
        imageName: item.imageName,
        isCropped: item.isCropped,
        isBatchCompleted: item.isBatchCompleted,
        imageId: item.imageId,
        businessName: item.businessName
      });

      imageTypeEntry.totalImages++;

      if (item.isCropped) {
        imageTypeEntry.totalUploadedImages++;
      }
      else {
        imageTypeEntry.isAllTypeImagesUploaded = false;
      }
    }

    const result: GroupedBusiness[] = [];

    for (const [businessId, businessEntry] of businessMap.entries()) {
      const imageTypeArray = Array.from(businessEntry.imageTypeMap.values());

      const isAllBusinessImagesUploaded = imageTypeArray.every((type) => type.isAllTypeImagesUploaded === true);
      result.push({
        businessId: businessId,
        businessName: businessEntry.businessName,
        approvalStatus: businessEntry.approvalStatus,
        isAllBusinessImagesUploaded: isAllBusinessImagesUploaded,
        businessImageData: imageTypeArray
      })
    }

    return result;
  }
}
